<template>
  <div class="modal fade" id="search-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-lg">
      <div class="modal-content" @click.stop>
        <div class="modal-header text-size-20 font-bold">フィルター設定</div>
        <div class="modal-body">
          <div class="flex flex-content-center">
            <table class="search-input">
              <thead>
                <tr>
                  <th class="w-95">フィルター名</th>
                  <th>フィルター内容</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="bg-light">ステータス</td>
                  <td>
                    <div v-for="item in arrJudgmentStatus" :key="item.text" :class="item.id === '' ? '' : 'radio-inline'">
                      <input type="radio" :value="item.id" name="filter-judgment-status" :id="`judgment-status-` + item.text" v-model="conditions.judgmentStatus">
                      <label class="input-label" :for="`judgment-status-${item.text}`">{{ item.text }}</label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="bg-light">受取金額</td>
                  <td>
                    <div v-for="item in arrAmountReceived" :key="item.text" :class="item.id === '' ? '' : 'radio-inline'">
                      <input type="radio" :value="item.id" name="filter-amount-received" :id="`amount-received-` + item.text" v-model="conditions.amountReceived">
                      <label class="input-label" :for="`amount-received-${item.text}`">{{ item.text }}</label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="flex flex-content-center mr-t-30">
            <table class="search-input">
              <thead>
                <tr>
                  <th class="w-95">フィルター名</th>
                  <th>フィルター内容</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="bg-light">倉庫情報</td>
                  <td>
                    <div class="boder-bottom-dotted">
                      <span>表示する倉庫：</span>
                      <div class="pd-l-5 pd-r-5 pd-t-10 pd-b-10">
                        <div v-for="item in arrWarehouse" :key="item.text" :class="item.id === '' ? '' : 'checkbox-inline'">
                          <input type="checkbox" :value="item.id" name="filter-warehouse" :id="`warehouse-` + item.text" v-model="conditions.warehouse">
                          <label :for="`warehouse-${item.text}`">
                            <img :src="icons[item.id]" class="w-20">
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <span>上記の内、在庫数：</span>
                      <div class="pd-l-20">
                        <div v-for="item in arrStockStatus" :key="item.text" :class="item.id === '' ? '' : 'radio-inline'">
                          <input type="radio" :value="item.id" name="filter-stock-status" :id="`stock-status-` + item.text" v-model="conditions.stockStatus">
                          <label class="input-label" :for="`stock-status-${item.text}`">{{ item.text }}</label>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer flex flex-content-center">
          <button class="btn btn-warning" @click="submitSearch">フィルターを設定する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      conditions: {...this.filters}
    }
  },
  props: {
    icons: {
      type: Object,
      default () {
        return {
          'Amazon': '',
          'salmonYamato': '',
          'salmonAcross': ''
        }
      }
    },
    arrJudgmentStatus: {
      type: Array,
      default: null
    },
    arrAmountReceived: {
      type: Array,
      default: null
    },
    arrWarehouse: {
      type: Array,
      default: null
    },
    arrStockStatus: {
      type: Array,
      default: null
    },
    filters: {
      type: Object,
      default () {
        return {
          keyword: '',
          judgmentStatus: '',
          stockStatus: '',
          warehouse: '',
          amountReceived: ''
        }
      }
    }
  },
  mounted () {
    $('#search-modal').modal('show')
  },
  methods: {
    submitSearch () {
      this.$emit('settingSearch', this.conditions)
    }
  }
}
</script>
<style scoped>
  .modal-header {
    border-bottom: none;
  }
  .modal-body {
    padding: 20px 30px;
  }
  .modal-lg {
    width: 700px;
  }
  .search-input {
    color: #595959;
    min-width: 550px;
  }
  .search-input th {
    background-color: #deebf7;
  }
  .search-input .bg-light {
    background-color: #f2f2f2;
  }
  .search-input th, td {
    border: 1px solid #bfbfbf;
    padding: 5px;
  }
  .input-label {
    font-weight: normal;
    color: black;
  }
  .checkbox-inline {
    padding-left: 40px;
  }
  .boder-bottom-dotted {
    border-bottom: 1px dotted #bfbfbf;
  }
  .modal-footer {
    background-color: unset;
    border-top: unset;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
  }
  .modal-content {
    border-radius: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/view/productsNew/SearchModal.vue